import { NgClass } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputErrorComponent } from '@common/components/input/input-error/input-error.component';
import { InputLabelComponent } from '@common/components/input/input-label/input-label.component';
import { TranslatePipe } from '@ngx-translate/core';
import { TextBoxComponent, TextBoxSuffixTemplateDirective } from '@progress/kendo-angular-inputs';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { BaseInputComponent } from '../base-input/base-input.component';
import { formatCharacterCount } from '../input.helpers';
import { TextInputConfig } from '../input.type';

/**
 * Text input component.
 * @param maxLength - The maximum length of the text.
 * @param minLength - The minimum length of the text.
 * @param pattern - The pattern of the text.
 */
@Component({
    selector: 'app-text-input',
    templateUrl: './text-input.component.html',
    styleUrls: ['./text-input.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [{ provide: BaseInputComponent, useExisting: TextInputComponent }],
    imports: [
        InputLabelComponent,
        TextBoxComponent,
        TranslatePipe,
        FormsModule,
        NgClass,
        InputErrorComponent,
        TooltipDirective,
        TextBoxSuffixTemplateDirective
    ]
})
export class TextInputComponent extends BaseInputComponent<string> implements OnInit, OnChanges {
    @Input() maxLength: TextInputConfig['maxLength'] = 255;
    @Input() minLength: TextInputConfig['minLength'];
    @Input() pattern: TextInputConfig['pattern'];
    @Input() password: TextInputConfig['password'] = false;
    characterCount: string;

    ngOnInit(): void {
        this.clearValue(this.value());
        this.characterCount = formatCharacterCount(this.maxLength, this.value());
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.value) this.clearValue(changes.value.currentValue);
    }

    override onValueChange(value: string): void {
        super.onValueChange(value);
        this.characterCount = formatCharacterCount(this.maxLength, value);
    }

    onKeyPress(event: KeyboardEvent) {
        if (!this.pattern) return;
        if (!new RegExp(this.pattern).test(event.key)) event.preventDefault();
    }

    // This is to avoid displaying 'undefined' when the value passed in is undefined eg.: model.username, where username is undefined.
    clearValue(value: string) {
        if (!value) this.value.set(null);
    }
}
